import React from 'react';

export const Footer = () => {
    return (
       
        <div className="flex flex-col items-center justify-between w-full p-4 border-gray-200 md:justify-center gradient-bg-footer bg-gradient-to-tr via-gray-300 from-gray-500 to-gray-900 dark:border-gray-700">
            <hi1> Web Rider </hi1> 
            <div className="text-sm "> 2022@DavidBarbedillo </div>
            
        </div>
    )
   
};

//export default Footer